import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import './login.css';
import logo from '../components/logo512.png';
import * as actions from '../store/actions/auth';
import Card from '../components/Card';
 

class RegistrationForm extends React.Component {
  constructor(props){
    super(props);
    
    this.state = {
      userName : '',
      email : '',
      password1 : '',
      password2 : '',
      buttonValue : true,
      passwordCheck : null,
      emailCheck : null
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePassword_too_Change = this.handlePassword_too_Change.bind(this);
  }


  handleChange = (event) => {
    var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    this.setState({email: event.target.value});
    
    if (this.state.password1.trim() !== '' && this.state.password1.trim() === this.state.password2.trim() && this.state.userName.trim() !== '' && event.target.value.match(mailformat) ) {
      
      this.setState({
        buttonValue: false,
        emailCheck: null
      }); 
    }
    else if ( !event.target.value.match(mailformat)) {
      this.setState({
        buttonValue: true,
        emailCheck: 'Invalid email'
      });
    }
    else {
      this.setState({
        buttonValue: true,
        emailCheck: null
      });
    }
    }; 
  handleUsernameChange = (event) => {
    
    var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    this.setState({userName: event.target.value});
    if (this.state.password1.trim() !== '' && this.state.password1.trim() === this.state.password2.trim() && this.state.email.match(mailformat) && event.target.value.trim() !== ''){
      
      this.setState({
        buttonValue: false
      }); 
    }
    else {
      this.setState({
        buttonValue: true
      });
    }
    }; 
    handlePasswordChange = (event) => {
      var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      
      this.setState({password1: event.target.value});
      if (this.state.userName.trim() !== '' && this.state.password2.trim() !=='' && event.target.value.trim() === this.state.password2.trim() && this.state.email.match(mailformat)){
        
        this.setState({
          passwordCheck: null,
          buttonValue: false
        }); 
      }
      else if (event.target.value.trim() !== this.state.password2.trim()) {
        this.setState({
          buttonValue: true,
          passwordCheck: 'doesn\'t match password'
        });
      }
      else {
       
        this.setState({
          buttonValue: true,
          passwordCheck: null
        }); 
      }
      }; 
  handlePassword_too_Change = (event) => {
    var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    this.setState({password2: event.target.value});
   
    if (this.state.userName.trim() !=='' && this.state.email.match(mailformat) && this.state.password1.trim() !=='' && this.state.password1.trim() === event.target.value.trim()){
      
      this.setState({
        passwordCheck: null,
        buttonValue: false,
      }); 
    }
    else if (event.target.value.trim() !== this.state.password1.trim()) {
      this.setState({
        buttonValue: true,
        passwordCheck: 'doesn\'t match password'
      });
    }
    else {
      
      this.setState({
        buttonValue: true,
        passwordCheck: null
      }); 
    }
    
    }; 
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onAuth(e.target.elements.userName.value, e.target.elements.email.value, e.target.elements.password1.value, e.target.elements.password2.value);
          
    }
    componentDidUpdate(prevProps) {
      if (this.props.token) {
        this.props.history.push('/HistoryList/')  
      } }

    render() { 
        let passworderrorMessage = this.state.passwordCheck
        let emailerrormessage = this.state.emailCheck
        let signuperrorMessage = null;
    if (this.props.error) {
      signuperrorMessage = (
            <h3>Please follow the guidelines above.</h3>
        );
    }
      return (
        <div className='bodyy'>
          <Card title = 'Guidelines' content = {<ul className='specialList'> 
            <li>Username is required to be between 150 characters or less.</li>
            <li>You can decide to use your email as your Username for ease of ACCESS.</li>
             <li>Username field accepts letters, digits and @/./+/-/_ only.</li>
            <li>If username already exists it would return an error.</li>
            <li>Your password must not be too similar to your other personal information.</li>
            <li>Your password must contain at least 8 characters.</li>
            <li>Your password must not be a commonly used password.</li>
            <li>Your password must not be entirely numeric.</li>
          </ul>} />
        <div id="login-box">
            {signuperrorMessage}
           {  this.props.loading ?
           <div className='footer-logo'>
            <h1 >Please wait</h1>
            <img  className='App-logo' src={logo} alt='logo'/> </div>
             :
        <div className="box">
                   
  <h1> Sign-up <span> or  
                    <NavLink id ="signup"
                        style={{marginRight: '10px',
                                paddingRight: '5px'}} 
                        to='/login/'> Click HERE to Login.
                    </NavLink>
</span></h1>
  
        <form onSubmit={this.handleSubmit} id="formElem" className="login-form">
          <label>
            Username:
            <input name="userName" type="text" onChange={this.handleUsernameChange} placeholder="Please input your username!"/>        </label>
            <label>
            Email:{emailerrormessage}
            <input name="email" type="email" onChange={this.handleChange} placeholder="Please input your valid Email!"/>        </label>
            <label>
            Password:
            <input name="password1" type="password" onChange={this.handlePasswordChange} placeholder="Please input your Password!"/>        </label>
            <label>
            Confirm Password:{passworderrorMessage}
            <input name="password2" type="password" onChange={this.handlePassword_too_Change} placeholder="Input your password again!"/>        </label>
         <div className='another_div'> <input type="submit" value="Signup"  disabled={this.state.buttonValue}/>
         
                    <NavLink id ="homepage"
                        style={{marginRight: '10px',
                                paddingLeft: '5px'  }} 
                        to='/'>Homepage
                    </NavLink>
                    </div>
        </form> 

        
        </div> }
        </div>
        </div>
      );
    }
} 


const mapStateToProps = (state) => {
    return {
        loading: state.loading,
        error: state.error,
        token: state.token
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (username, email, password1, password2) => dispatch(actions.authSignup(username, email, password1, password2)) 
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationForm);
